import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppToastComponent } from '@shared/components/app-toast/app-toast.component';
import { AppTransitionOverlayComponent } from '@shared/components/app-transition-overlay/app-transition-overlay.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AppToastComponent, AppTransitionOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  title = 'faisen-superadmin-web';
}
